function formatPrice(value) {
    if (value !== '' && value !== null && value !== 'undefined') {
        let val = (value / 1).toFixed(2).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }
    else {
        return 0.00
    }
}

export {
    formatPrice,
}